module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d8bU3"))).then(() => parcelRequire('1iHdE'));